(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.LoginController = (function(superClass) {
    extend(LoginController, superClass);

    function LoginController(scope, transitions, $state, $modal, $http, $q, $stateParams, Routing, Session) {
      var base, pendingEmail;
      this.scope = scope;
      this.transitions = transitions;
      LoginController.__super__.constructor.apply(this, arguments);
      if (Session.get('Authorization')) {
        return Routing.determineDestination($stateParams);
      }
      this.scope.branding = $stateParams.b;
      pendingEmail = $stateParams.pending_email;
      this.scope.registration_token = $stateParams.registration_token;
      $('#outer_messagewrapper').message_writer({
        autoHide: false
      });
      this.scope.username = pendingEmail != null ? pendingEmail : '';
      if ((base = this.scope).password == null) {
        base.password = '';
      }
      this.scope.resetPassword = (function(_this) {
        return function(email) {
          var dlg, newScope;
          newScope = _this.scope.$new();
          newScope.params = {
            email: email
          };
          return dlg = $modal.open({
            windowClass: 'small_dialog',
            templateUrl: 'backend/session-mgmt/forgot-password-layout',
            controller: 'Main.Controllers.ForgotPasswordController',
            scope: newScope
          });
        };
      })(this);
      if ($stateParams.reset_email) {
        this.scope.resetPassword($stateParams.reset_email);
      }
      this.scope.login = (function(_this) {
        return function() {
          $('#outer_messagewrapper').message_writer('info', 'Logging in...');
          return $http.post((Config.get('api_url')) + "/auth", {
            identifier: _this.scope.username,
            password: _this.scope.password,
            pendingEmail: pendingEmail
          }).then(function(response) {
            var token;
            token = response.data.token;
            Session.set('Authorization', "Bearer " + token);
            Session.set('SafeLink', "Bearer " + token);
            Session.set('OriginalUser', "Bearer " + token);
            Session.set('AuthTime', new Date().getTime());
            $http.get((Config.get('api_url')) + "/me").then(function(response) {
              Socket.whenopen(function() {
                var ref;
                return (ref = Socket.socket) != null ? ref.send(response.data.id) : void 0;
              });
              return typeof Raven !== "undefined" && Raven !== null ? Raven.setUserContext(response.data) : void 0;
            });
            $('#outer_messagewrapper').message_writer('success', 'Logged In');
            Routing.determineDestination($stateParams);
            return response;
          })["catch"](function(err) {
            var message;
            if (err.status === 403 && err.data.error === 'inactive') {
              message = 'Your account is inactive, therefore, you cannot login to MyFarms. If you believe this has happened in error, please contact support@myfarms.com.';
            } else if (err.status === 403) {
              message = "It looks like your account hasn't been authenticated yet. Check your email for an authentication link or contact your advisor for help.";
            } else {
              message = 'Invalid Credentials';
            }
            $('#outer_messagewrapper').message_writer('error', message);
            return $q.reject(err);
          });
        };
      })(this);
    }

    return LoginController;

  })(Controller);

}).call(this);
